export function deleteAllDatabases() {
  const DBDeleteRequest = window.indexedDB
    .databases()
    .then(function (databases) {
      databases.forEach(function (db) {
        window.indexedDB.deleteDatabase(db.name);
      });
    });

  return DBDeleteRequest;
}
